import { DigitalPassport } from "../types/battle"
import { ONBOARDING_STEP_ORDER } from "../constants/gameMeta"
import { OnboardingResponse, OnboardingStepKey } from "../types/gameMeta"

export function hasSelectedLeague(passport: DigitalPassport): boolean {
  return passport.academicLeague === "TITAN" || passport.academicLeague === "ATLANT"
}

export function hasSelectedAffiliation(passport: DigitalPassport): boolean {
  return Boolean(passport.affiliationElement)
}

export function needsAffiliationSelection(passport: DigitalPassport): boolean {
  if (passport.needsAffiliationSelection) return true
  if (passport.affiliationElement) return false
  return hasSelectedLeague(passport)
}

export function needsGuardianPathSelection(passport: DigitalPassport): boolean {
  if (passport.needsGuardianPathSelection) return true
  if (passport.guardianPath) return false
  return hasSelectedLeague(passport)
}

function hasActiveCard(passport: DigitalPassport): boolean {
  return Boolean(passport.activeCardId || passport.activeCard?.id)
}

function hasDailyQuizDone(passport: DigitalPassport): boolean {
  return Boolean(passport.lastQuizTaken?.trim())
}

/** Сверяет шаги онбординга с фактическим состоянием паспорта. */
export function reconcileOnboardingWithPassport(
  data: OnboardingResponse,
  passport: DigitalPassport | null
): OnboardingResponse {
  if (!passport) return data

  const inferred: Partial<Record<OnboardingStepKey, boolean>> = {}
  if (hasSelectedLeague(passport)) inferred.LEAGUE_SELECTED = true
  if (hasActiveCard(passport)) inferred.ACTIVE_CARD_SET = true
  if (hasDailyQuizDone(passport)) inferred.DAILY_QUIZ_DONE = true

  const steps = data.steps.map((step) =>
    inferred[step.key] && !step.completed ? { ...step, completed: true } : step
  )

  const completedCount = steps.filter((step) => step.completed).length
  const totalSteps = data.totalSteps || ONBOARDING_STEP_ORDER.length
  const hasPassport = data.hasPassport || hasSelectedLeague(passport)

  return {
    ...data,
    steps,
    completedCount: Math.max(data.completedCount, completedCount),
    totalSteps,
    hasPassport,
    isComplete: hasPassport && completedCount >= totalSteps && totalSteps > 0,
  }
}
